import React from 'react'

import { Typo } from 'components/_old/Typo'

import { Typography } from 'components/atoms/Typography'

function PastPerformanceDisclaimer(): JSX.Element {
  return (
    <div className="PastPerformanceDisclaimer">
      <Typography size={12} color="minor">
        <Typo>
          Source: Bloomberg. This table shows a hypothetical example of how this portfolio might have grown, based on
          past data of the current ETFs in our Managed Portfolios. It shows returns after fees but trading costs like
          spreads aren't included. This is for illustration only — results aren't guaranteed, and the asset mix may
          change. Investments can go up or down, so you might get back less than you invested. Past performance doesn't
          show how it'll perform in the future
        </Typo>
      </Typography>
    </div>
  )
}

export { PastPerformanceDisclaimer }
